import React from 'react'
import CardChart from '../Components/CardChart'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Skeleton
} from '@mui/material'
import useFetchData from '../../../../../../hooks/useFetchData'
import FormatDate from '../../../../../date/FormatDate'

const MyRecentMarkingActivity = ({ userId }) => {
  const { isLoading, data } = useFetchData(`dashboard/teacher/${userId}/my-recent-marking-activity`)
  return (
    <CardChart title='My Recent Marking Activity' bgColor='#fff' px={0}>
      <TableContainer sx={{ borderRadius: '8px', overflow: 'hidden' }}>
        <Table>
          <TableBody>
            {isLoading ? (
              Array.from({ length: 5 }).map((_, i) => (
                <TableRow key={i}>
                  <TableCell width={'220px'} sx={{ px: 2.5 }}>
                    <Typography color='textSecondary' className='capitalize'>
                      <Skeleton width={100} height={20} />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant='body2' color='textPrimary'>
                      <Skeleton width={100} height={20} />
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            ) : data?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} sx={{ px: 2.5 }}>
                  <Typography variant='body2' color='textSecondary'>
                    No recent activity
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              data?.map((activity, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ px: 2.5 }}>
                    <Typography className=' capitalize'>
                      {activity?.action} {activity?.module === 'note' ? 'note' : ''}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color='textSecondary'>
                      <FormatDate date={activity?.createdAt} />
                    </Typography>
                  </TableCell>
                  <TableCell align='left'>
                    {activity?.class && (
                      <Box className='flex items-center justify-start gap-1'>
                        <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                          class
                        </Typography>
                        <Typography variant='body2' color='textPrimary' className=' '>
                          {activity?.class || 'N/A'}
                        </Typography>
                      </Box>
                    )}
                    {activity?.subject && (
                      <Box className='flex items-center justify-start gap-1'>
                        <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                          subject
                        </Typography>
                        <Typography variant='body2' color='textPrimary' className=' '>
                          {activity?.subject || 'N/A'}
                        </Typography>
                      </Box>
                    )}
                    {activity?.ul && (
                      <Box className='flex items-center justify-start gap-1'>
                        <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                          unit of learning
                        </Typography>
                        <Typography variant='body2' color='textPrimary' className=' '>
                          {activity?.ul || 'N/A'}
                        </Typography>
                      </Box>
                    )}
                    {activity?.lc && (
                      <Box className='flex items-center justify-start gap-1'>
                        <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                          Learning continua
                        </Typography>
                        {activity?.lc?.[activity?.lc?.length - 1] ? (
                          <Typography variant='body2' color='textPrimary' className=' '>
                            {activity?.lc?.[activity?.lc?.length - 1]?.name || 'N/A'}
                          </Typography>
                        ) : (
                          <Typography variant='body2' color='textPrimary' className=' '>
                            N/A
                          </Typography>
                        )}
                      </Box>
                    )}
                    {activity?.level && (
                      <Box className='flex items-center justify-start gap-1'>
                        <Typography variant='body2' color='primary' className='uppercase text-xs font-bold'>
                          level
                        </Typography>
                        <Typography variant='body2' color='textPrimary' className=' '>
                          {activity?.level || 'N/A'}
                        </Typography>
                      </Box>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </CardChart>
  )
}

export default MyRecentMarkingActivity
